// components/StudentPortal/ModeSelect/ModeSelect.js
// S0 - Seleccion de modo (VR / pantalla). Primera decision del alumno antes de
// entrar al portal. Preselecciona VR si el navegador es Quest. La eleccion se
// persiste (studentModeStore) y se puede cambiar luego desde el header.
// Iconos placeholder (emoji) en F3; los iconos finales (estilo clay de los
// mockups) entran en F4. Tokenizado: var(--edu-*, fallback).
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useStudentModeStore,
  detectQuest,
} from "../../../store/studentModeStore";
import { logoEduca } from "../../../assets";
import styles from "./ModeSelect.module.scss";

export function ModeSelect() {
  const { t } = useTranslation("students");
  const setMode = useStudentModeStore((s) => s.setMode);
  const [selected, setSelected] = useState(detectQuest() ? "vr" : "screen");

  const options = [
    {
      key: "vr",
      icon: "🥽",
      title: t("mode.vrTitle"),
      caption: t("mode.vrCaption"),
    },
    {
      key: "screen",
      icon: "💻",
      title: t("mode.screenTitle"),
      caption: t("mode.screenCaption"),
    },
  ];

  return (
    <div className={styles.wrap}>
      <header className={styles.topbar}>
        <img src={logoEduca.logoE360} alt="Educa360" className={styles.logo} />
      </header>

      <main className={styles.main}>
        <h1 className={styles.question}>{t("mode.question")}</h1>
        <p className={styles.subtitle}>{t("mode.subtitle")}</p>

        <div className={styles.cards}>
          {options.map((opt) => (
            <button
              key={opt.key}
              type="button"
              className={`${styles.card} ${
                selected === opt.key ? styles.selected : ""
              }`}
              aria-pressed={selected === opt.key}
              onClick={() => setSelected(opt.key)}
              onDoubleClick={() => setMode(opt.key)}
            >
              <span className={styles.icon} aria-hidden="true">
                {opt.icon}
              </span>
              <span className={styles.cardTitle}>{opt.title}</span>
              <span className={styles.cardCaption}>{opt.caption}</span>
            </button>
          ))}
        </div>

        <button
          type="button"
          className={styles.cta}
          onClick={() => setMode(selected)}
        >
          {t("mode.continue")}
        </button>
      </main>
    </div>
  );
}
